import React, { useMemo } from 'react';
import cn from 'classnames';

const BriefFamilyPerson = ({
  maleLabel = 'Male',
  femaleLabel = 'Female',
  value: person,
  invalid,
  onChange,
}) => {
  const isDirty = useMemo(() => !!person.gender || !!person.age, [person]);
  return (
    <div
      className={cn('member-selection_row -border', {
        'has-error -error-position-bottom': invalid && !person.gender,
      })}
    >
      <label
        className="member-selection_checkbox"
        onClick={e => {
          e.preventDefault();
          onChange({ ...person, gender: 'male' });
        }}
      >
        <input
          className="member-selection_checkbox-input"
          type="radio"
          readOnly
          value="male"
          checked={person.gender === 'male'}
        />
        <span className="member-selection_checkbox-label -mint -highlight-mint">{maleLabel}</span>
      </label>

      <label
        className="member-selection_checkbox"
        onClick={e => {
          e.preventDefault();
          onChange({ ...person, gender: 'female' });
        }}
      >
        <input
          className="member-selection_checkbox-input"
          type="radio"
          readOnly
          value="female"
          checked={person.gender === 'female'}
        />
        <span className="member-selection_checkbox-label -mint -highlight-mint">{femaleLabel}</span>
      </label>

      <div
        className={cn('form-group member-selection_input real-value -age', {
          'has-error -error-position-bottom': (isDirty || invalid) && !person.age,
        })}
      >
        <input
          className="form-control"
          value={person.age}
          placeholder="Age"
          type="number"
          onChange={e => {
            e.preventDefault();
            onChange({ ...person, age: e.target.value });
          }}
        />
      </div>
    </div>
  );
};

export default BriefFamilyPerson;



// WEBPACK FOOTER //
// ./app/javascript/components/brief/components/BriefFamily/BriefFamilyPerson.js